import { BaseService } from './base.service';

export interface AppVersionPlatformInfo {
  latest: string;
  force: boolean;
  storeUrl: string;
}

export interface AppVersionConfig {
  enabled: boolean;
  ios: AppVersionPlatformInfo;
  android: AppVersionPlatformInfo;
}

class AppVersionServiceClass extends BaseService {
  constructor() {
    super('/housekeeping');
  }

  getAppVersion(): Promise<AppVersionConfig> {
    return this.get<AppVersionConfig>('/app-version');
  }
}

export const AppVersionService = new AppVersionServiceClass();
